<template>
  <div class="box-father" v-loading="exportLoading">
    <div style="height: 100%" v-if="!dialogTableVisible">
      <div class="box-header">
        <div class="box-header-left">
          <div class="box-header-left-text">审核打卡管理&nbsp;/&nbsp;</div>
          <div class="box-header-right">
            <div>垃圾桶站打卡列表</div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="日期">
                  <el-date-picker
                    v-model="form.dayStr"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择时间"
                    :clearable="false"
                    @change="onSearch"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="打卡人">
                  <el-input
                    v-model="form.createUserName"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="垃圾桶站名称">
                  <el-input
                    v-model="form.eventName"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="是否打卡">
                  <el-select
                    filterable
                    placeholder="请选择"
                    clearable
                    v-model="form.hasRecordFlag"
                  >
                    <el-option
                      v-for="item in rengongList"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否含人工审核">
                  <el-select
                    filterable
                    placeholder="请选择"
                    clearable
                    v-model="form.hasAdminAuditFlag"
                  >
                    <el-option
                      v-for="item in shenheList"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <div class="table-top-btns">
            <div class="left-btn">
              <div class="mr-40" v-for="(item, index) in shanghuCount" :key="index">
                {{ item.label }}：<span class="cl-primary">{{ item.value }}</span>家
              </div>
            </div>
            <!-- <div class="right-btn">
              <el-button
                @click="dutyWordExp"
                icon="el-icon-download"
                class="search"
                >导出列表</el-button
              >
            </div> -->
          </div>
          <common-table
            :select="false"
            :page="page"
            :dataList="dataList"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            :maxHeight="540"
          >
            <template v-slot:createTime>
              <span>{{ form.dayStr }}</span>
            </template>
            <template v-slot:rangeHourTime="{ scope }">
              <el-tooltip v-if="scope.row.createUserNames" class="item" effect="dark" :content="scope.row.createUserNames" placement="top">
                <span>{{ scope.row.auditCount || 0 }}/<span class="pointer cl-primary">{{ scope.row.taskCount || 0 }}</span> </span>
              </el-tooltip>
              <span v-else>{{ scope.row.auditCount || 0 }}/{{ scope.row.taskCount || 0 }}</span>
            </template>
            <template v-slot:workContent="{ scope }">
              <span>{{ scope.row.auditCount ? '是' : '否' }}</span>
            </template>
            <!-- 智能识别结果 -->
            <template v-slot:zhinshibie="{ scope }">
              <span style="margin-right: 5px;" v-for="(item, index) in scope.row.aiAuditStates && scope.row.aiAuditStates.split(',')" :key="index" :class="item == '已通过' ? 'pass' : item == '不通过' ? 'noPass' : 'warin'" >{{ item }}</span>
            </template>
            <!-- 人工审核结果 -->
            <template v-slot:submitFlag="{ scope }">
              <span style="margin-right: 5px;" v-for="(item, index) in scope.row.auditStates && scope.row.auditStates.split(',')" :key="index" :class="item == '已通过' ? 'pass' : item == '不通过' ? 'noPass' : 'warin'" >{{ item }}</span>
            </template>
            <template v-slot:operation="{ scope }">
              <el-button
                @click="manualReview(scope.row)"
                style="font-size: 16px"
                type="text"
                >人工审核</el-button
              >
              <el-button
                @click="qusetionDetail(scope.row)"
                style="font-size: 16px"
                type="text"
                >详情</el-button
              >
            </template>
          </common-table>
        </div>
      </div>
    </div>
    <detailForm
      v-else
      :item="currentItem"
      :dayStr="form.dayStr"
      :dialogType="dialogType"
      @closeDialog="closeDetail"
    ></detailForm>
  </div>
</template>

<script>
import {
  dutyWordExp,
  byShanghuAnisPage2,
  subSubmitCount
} from "@/api/task.js";
import commonTable from "@/components/table/index.vue";
import moment from "moment";
import detailForm from "./detailForm.vue";
export default {
  components: {
    detailForm,
    commonTable
  },
  data() {
    return {
      loading: false,
      dialogTableVisible: false,
      currentItem: {},
      dialogVisible2: false,
      exportLoading: false,
      exportForm: {
        createTimeEnd: "",
        createTimeStart: "",
        searchSource: "",
        valueTime: [],
        eventType: "",
        state: ""
      },
      actionsTwo: [],
      form: {
        createUserName: "",
        eventName: "",
        pian: "",
        sq: "",
        zu: "",
        dayStr: moment(new Date()).format("YYYY-MM-DD"),
        hasRecordFlag: '',
        hasAdminAuditFlag: ''
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "eventName",
            label: "垃圾桶站名称"
          },
          {
            slot: "createTime",
            label: "日期",
          },
          {
            slot: "rangeHourTime",
            label: "人工审核次数/打卡次数"
          },
          {
            slot: "workContent",
            label: "是否人工审核"
          },
          {
            slot: "zhinshibie",
            label: "智能识别结果",
            width: "200px",
            showToolitip: '1'
          },
          {
            slot: "submitFlag",
            label: "人工审核结果",
            width: "200px",
            showToolitip: '1'
          },
          {
            slot: "operation",
            label: "操作",
            width: "200px"
          }
        ]
      },
      exportLoading: false,
      // 是否人工审核
      shenheList: [
        {
          value: '是',
          text: "是"
        },
        {
          value: '否',
          text: "否"
        }
      ],
      rengongList: [
        {
          value: '是',
          text: "是"
        },
        {
          value: '否',
          text: "否"
        }
      ],
      // 审核/详情
      dialogType: "",
      shanghuCount: []
    };
  },
  mounted() {
    this.getPointTypeListPageFun();
    this.getShanghuCount();
  },
  methods: {
    closeDetail () {
      this.dialogTableVisible = false;
      this.getPointTypeListPageFun();
      this.getShanghuCount();
    },
    // 人工审核
    manualReview(row) {
      this.currentItem = row;
      this.dialogTableVisible = true;
      this.dialogType = "审核";
      this.currentItem.fileJson = [
        {
          url:
            "https://gxai.bjhddsj.cn/zgc-api-gw/gh-app-server/file/download?filePath=imgPic/1756459242131_b5834485.jpg"
        },
        {
          url:
            "https://gxai.bjhddsj.cn/zgc-api-gw/gh-app-server/file/download?filePath=imgPic/1756459242131_b5834485.jpg"
        }
      ];
    },
    // 详情
    qusetionDetail(row) {
      this.currentItem = row;
      this.dialogTableVisible = true;
      this.dialogType = "详情";
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
      this.getShanghuCount();
    },
    onReset() {
      this.form.createUserName = '';
      this.form.eventName = '';
      this.form.pian = '';
      this.form.sq = '';
      this.form.zu = '';
      this.form.dayStr = moment(new Date()).format("YYYY-MM-DD");
      this.page.page = 1;
      this.page.size = 10;
      this.form.hasRecordFlag = '';
      this.form.hasAdminAuditFlag = '';
      this.getPointTypeListPageFun();
    },
    // 导出
    async dutyWordExp() {
      this.exportLoading = true;
      let res = await dutyWordExp({
        ...this.form,
        page: this.page.page,
        size: this.page.size
      });
      if (res.status == 200) {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "垃圾桶站打卡列表" + new Date().getTime() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      }
      this.exportLoading = false;
    },
    // 分页查询
    async getPointTypeListPageFun() {
      let params = {
        ...this.form,
        page: this.page.page,
        size: this.page.size,
      };
      const res = await byShanghuAnisPage2(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data ? (res.data.data.records
          ? res.data.data.records
          : []) : [];
        this.page.total = res.data ? res.data.data.total : 0;
      } else return this.$message.error(res.data.msg)
    },

    // 查询商户提交情况（后台列表统计）
    async getShanghuCount() {
      if (!this.form.dayStr) return false;
      let params = {
        dayStr: this.form.dayStr,
      };
      const res = await subSubmitCount(params);
      if (res.data.code == 200) {
        this.shanghuCount = res.data.data;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";
.cl-primary {
  color: #008cff;
}
.mr-40 {
  margin-right: 40px;
}
.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}

.tuihui {
  color: #eb3538;
  font-size: 16px;
}

.fileJson {
  img {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

/deep/ .el-carousel__arrow {
  width: 54px !important;
  height: 54px !important;
  font-size: 18px !important;
}
.pass {
  color: #17b3ad;
}
.noPass {
  color: #ff5348;
}
.warin {
  color: #FFA200;
}
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/mCheckInManage/tzClockList/index.vue